export default "<p>accounting works!</p>\r\n"